import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'send.title',
        defaultMessage: 'Send',
    },
})
